{
  "Good Morning": "Goedemorgen",
  "Good Afternoon": "Goedemiddag",
  "Good Evening": "Goedeavond",
  "Here is what's happening in your account today": "Dit gebeurt er vandaag in je account",
  "News": "Nieuws",
  "Favourites": "Favorieten",
  "Greetings": "Groeten",
  "Team Members": "Team leden",
  "Service Desk": "Service Desk",
  "Service Manager": "Service Manager",
  "Project Manager": "Project Manager",
  "Technical Consultant": "Technisch Consultant",
  "Employee": "Medewerker",
  "Oops... There seems to be a problem...": "Oeps... Er lijkt een probleem te zijn...",
  "There was an error while loading the page.": "Er is een fout opgetreden bij het laden van de pagina.",
  "Something went wrong while loading this page.": "Er is iets misgegaan bij het laden van deze pagina.",
  "Let us know using the feedback function if you think this is a mistake.": "Laat het ons weten met de feedbackfunctie als je denkt dat dit een fout is.",
  "Please try again later.": "Probeer het later opnieuw.",
  "There are no customers or invitations configured for this user.": "Er zijn geen klanten of uitnodigingen geconfigureerd voor deze gebruiker.",
  "You are not yet known in the Ekco Sphere": "Je bent nog niet bekend in de Ekco Sphere",
  "This is probably because you have not been invited by your organisation.": "Dit komt waarschijnlijk omdat je niet uitgenodigd bent door je organisatie.",
  "New Invitation": "Nieuwe uitnodiging",
  "New Invitations": "Nieuwe uitnodigingen",
  "Your user is not a member of any customer. To continue, please accept an invitation.": "Uw gebruiker is geen lid van een klant. Om door te gaan, accepteer een uitnodiging.",
  "You have been invited to ": "Je bent uitgenodigd voor: ",
  "Multiple invitations are awaiting review.": "Er wachten meerdere uitnodigingen op beoordeling.",
  "Review": "Bekijk",
  "Ignore": "Negeren",
  "Restart": "Herstarten",
  "Failed to load Sphere": "Sphere kon niet geladen worden",
  "No customer or invitations found for this user.": "Er zijn geen klanten of uitnodigingen gevonden voor deze gebruiker.",
  "No valid customers found for this user.": "Er zijn geen geldige klanten gevonden voor deze gebruiker.",
  "Contact support": "Contact",
  "Close": "Sluiten",
  "Cancel": "Annuleren",
  "Please try again later": "Probeer het later opnieuw",
  "Create Favourite": "Bladwijzer maken",
  "Delete Favourite?": "Bladwijzer verwijderen?",
  "Are you sure you want to delete this favourite?": "Weet je zeker dat je deze bladwijzer wilt verwijderen?",
  "Yes": "Ja",
  "Log out": "Uitloggen",
  "Network Error": "Netwerkfout",
  "Submit": "Indienen",
  "Confirm": "Bevestigen",
  "You do not have permission to perform this action.": "Je hebt geen toestemming om deze actie uit te voeren.",
  "Give Feedback to Ekco": "Feedback geven aan Ekco",
  "Summarise your feedback": "Vat je feedback samen",
  "Please contact support if you require further assistance.": "Neem contact op met de ondersteuning als je meer hulp nodig hebt.",
  "Send to Ekco": "Stuur naar Ekco",
  "Provide a rating": "Geef een beoordeling",
  "Rating is required": "Beoordeling is vereist",
  "Start typing..": "Begin met typen..",
  "Source View": "Bronweergave",
  "Rendered View": "Gerenderde weergave",
  "Reset": "Resetten",
  "Invalid URL": "Ongeldige URL",
  "Please enter a valid URL": "Voer een geldige URL in",
  "Invalid Name": "Ongeldige naam",
  "Please enter a valid name": "Voer een geldige naam in",
  "Invalid URL/Name": "Ongeldige URL/naam",
  "Please check that you have input a valid URL and Name": "Controleer of u een geldige URL en naam heeft ingevoerd",
  "No data found": "Geen data gevonden",
  "Add": "Toevoegen",
  "Add Favourite": "Bladwijzer toevoegen",
  "Loading...": "Laden...",
  "Request failed with status code 404": "Verzoek mislukt met statuscode 404",
  "Page not found": "Pagina niet gevonden",
  "The page you are looking for does not exist or has moved.": "De pagina die je zoekt bestaat niet of is verplaatst.",
  "Check the address, or use the menu to find what you need.": "Controleer het adres, of gebruik het menu om te vinden wat je nodig hebt.",
  "Return to the homepage": "Keer terug naar de home pagina",
  "We use cookies to enhance your experience. For a complete overview of all cookies used and more info, please see our ": "We gebruiken cookies om je ervaring te verbeteren. Voor een volledig overzicht van alle gebruikte cookies en meer info, zie ons ",
  "Cookie Policy": "Cookiebeleid",
  "Accept": "Accepteren",
  "Decline": "Afwijzen",
  "Accept cookies": "Cookies accepteren",
  "Decline cookies": "Cookies afwijzen",
  "Would you like to report a bug, raise a ticket, or send feedback?": "Wil je een bug melden, een ticket openen of feedback sturen?",
  "Report a bug": "Rapporteer een bug",
  "Request a feature": "Nieuwe functionaliteit aanvragen",
  "Provide Feedback": "Geef feedback",
  "Rate your experience": "Beoordeel je ervaring",
  "Rate your experience is required": "Beoordeel je ervaring is vereist",
  "Back": "Terug",
  "Refresh": "Verversen",
  "Delete File?": "Verwijder Bestand?",
  "Delete Folder?": "Verwijder Folder?",
  "Overwrite Existing Files?": "Bestaande bestanden overschrijven?",
  "Language": "Taal",
  "Theme": "Thema",
  "More info": "Meer info",
  "Settings": "Instellingen",
  "Open Settings Menu": "Open het instellingenmenu",
  "Open Profile": "Profiel openen",
  "Switch the customer you are working on.": "Wissel de klant die actief is.",
  "Dark Mode": "Donkere modus",
  "Developer": "Ontwikkelaar",
  "Light": "Licht",
  "Dark": "Donker",
  "Light (colorblind)": "Licht (kleurenblind)",
  "Dark (colorblind)": "Donker (kleurenblind)",
  "Preferences": "Voorkeuren",
  "Account": "Account",
  "Customer": "Klant",
  "Coming Soon": "Binnenkort",
  "Create User": "Gebruiker aanmaken",
  "Invitations": "Uitnodigingen",
  "Users": "Gebruikers",
  "Contacts": "Contacten",
  "Demo Customers": "Demo Klanten",
  "Add demo customer": "Demo klant toevoegen",
  "Switch to new demo customer?": "Overschakelen naar nieuwe demo klant?",
  "Active until": "Actief tot",
  "Edit demo customer": "Demo klant bewerken",
  "Select": "Selecteren",
  "Source Systems": "Bronsystemen",
  "Login Policy": "Inlogbeleid",
  "Ekco Virtual Assistant": "Ekco Virtual Assistant",
  "Let us know using the  ": "Laat het ons weten met behulp van de ",
  "feedback": "feedback",
  " function if you think this is a mistake": " functie als je denkt dat dit een fout is",
  "Insights": "Inzichten",
  "Name": "Naam",
  "Date Modified": "Wijzigingsdatum",
  "Modified": "Gewijzigd",
  "Size": "Grootte",
  "Type": "Type",
  "Delete": "Verwijderen",
  "Remove": "Verwijderen",
  "Go Back": "Ga Terug",
  "Upload File": "Bestand Uploaden",
  "New folder": "Nieuwe map",
  "Copy": "Kopiëren",
  "Cut": "Knippen",
  "Paste": "Plakken",
  "Delete items?": "Items verwijderen?",
  "Are you sure you want to delete this item? This action cannot be undone.": "Weet je zeker dat je dit item wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
  "Are you sure you want to delete \"{}\"?": "Weet je zeker dat je \"{}\" wilt verwijderen?",
  "Are you sure you want to delete {} items?": "Weet je zeker dat je de {} items wilt verwijderen?",
  "Are you sure you want to delete": "Weet je zeker dat je wilt verwijderen",
  "items": "items",
  "This includes folders and all their contents.": "Dit is inclusief mappen en hun inhoud.",
  "This action cannot be undone.": "Deze actie kan niet ongedaan worden gemaakt.",
  "Some files failed to upload:": "Sommige bestanden konden niet worden geüpload:",
  "Rename": "Hernoemen",
  "Rename Item": "Item hernoemen",
  "Create New Item": "Nieuw item maken",
  "Item Name": "Itemnaam",
  "Enter new name": "Voer nieuwe naam in",
  "Enter item name": "Voer itemnaam in",
  "Create": "Maken",
  "File name cannot be empty": "Bestandsnaam mag niet leeg zijn",
  "File name cannot be more than 1,024 characters long": "Bestandsnaam mag niet langer zijn dan 1.024 tekens",
  "File name cannot end with a dot": "Bestandsnaam mag niet eindigen met een punt",
  "File name contains invalid characters": "Bestandsnaam bevat ongeldige tekens",
  "Failed to create item. Please try again.": "Item maken mislukt. Probeer het opnieuw.",
  "Failed to rename. Please try again.": "Hernoemen mislukt. Probeer het opnieuw.",
  "Download": "Downloaden",
  "Preview or Download": "Bekijken of Downloaden",
  "This folder does not exist in the selected language. Please switch and try again.": "Deze map bestaat niet in de geselecteerde taal. Schakel over en probeer het opnieuw.",
  "An error occurred while fetching folder data.": "Er is een fout opgetreden bij het ophalen van mapgegevens.",
  "Appearance": "Uiterlijk",
  "Customize how Sphere looks on your device.": "Pas aan hoe Sphere er op uw apparaat uitziet.",
  "Change the language used in the user interface.": "Wijzig de taal van de gebruikersinterface.",
  "Delete Invitation?": "Uitnodiging verwijderen?",
  "Are you sure you wish to delete": "Weet u zeker dat u wilt verwijderen",
  "Delete Contact?": "Contact verwijderen?",
  "this contact": "dit contact",
  "contacts": "contacten",
  "for": "voor",
  "Delete Role?": "Rol verwijderen?",
  "Create Contacts": "Contacten aanmaken",
  "User": "Gebruiker",
  "Title": "Titel",
  "Update": "Bijwerken",
  "Search for {}": "Zoek naar {}",
  "No results found.": "Geen resultaten gevonden.",
  "Please try again using the search button.": "Probeer het opnieuw met de zoekknop.",
  "Search": "Zoeken",
  "Search or go to...": "Zoek of ga naar...",
  "Navigate": "Navigeren",
  "Enter": "Enter",
  "Open": "Openen",
  "Find pages throughout Sphere": "Vind pagina's in Sphere",
  "What are you looking for today?": "Wat zoekt u vandaag?",
  "No results for": "Geen resultaten voor",
  "Documents": "Documenten",
  "Folders": "Folders",
  "Pages": "Pagina's",
  "Reports": "Rapportages",
  "Switch customer": "Klant wisselen",
  "Current": "Huidig",
  "Recent searches": "Recente zoekopdrachten",
  "Suggested": "Aanbevolen",
  "Recently visited": "Recent bezocht",
  "Help": "Hulp",
  "Didn't find what you were looking for? Try again or let us know what you are looking for.": "Niet gevonden wat je zocht? Probeer opnieuw of laat ons weten wat je zoekt.",
  "Try": "Probeer",
  "Open settings": "Ga naar",
  "Switch to dark theme": "Overschakelen naar donker thema",
  "Switch to light theme": "Overschakelen naar licht thema",
  "Switch to English": "Overschakelen naar Engels",
  "Switch to Nederlands": "Overschakelen naar Nederlands",
  "Sources": "Bronnen",
  "No {} found for your user to assign.": "Geen {} gevonden die uw gebruiker kan toewijzen.",
  "Update Role": "Rol bijwerken",
  "No roles found for your user to assign.": "Geen rollen gevonden die uw gebruiker kan toewijzen.",
  "Enter a valid email address.": "Voer een geldig e-mailadres in.",
  "Email is required": "E-mail is verplicht",
  "Add an email": "Voeg een e-mail toe",
  "Additional resources": "Meer bronnen",
  "Email Addresses": "E-mailadressen",
  "Press enter to add a email": "Druk op Enter om een e-mail toe te voegen",
  "Select a role": "Selecteer een rol",
  "Roles for Customer": "Rollen voor klant",
  "Groups for Customer": "Groepen voor klant",
  "Select a group": "Selecteer een groep",
  "One or more emails contain an invalid domain name. Please enter an email that contains": "Een of meer e-mails bevatten een ongeldige domeinnaam. Voer een e-mail in die bevat",
  "only": "alleen",
  "Send": "Verzenden",
  "Sent": "Verzonden",
  "Email": "E-mail",
  "Inviter": "Uitnodiger",
  "Customers": "Klanten",
  "Roles": "Rollen",
  "Groups": "Groepen",
  "Expiration": "Verloopt",
  "Update Customers": "Klanten bijwerken",
  "Update Roles": "Rollen bijwerken",
  "Update Groups": "Groepen bijwerken",
  "User Management": "Gebruikersbeheer",
  "Roles are used to determine a user's feature permissions for a selected customer.": "Rollen worden gebruikt om de functietoestemmingen van een gebruiker voor een geselecteerde klant te bepalen.",
  "Groups are used to determine a user's ability to perform certain actions in Sphere.": "Groepen worden gebruikt om het vermogen van een gebruiker te bepalen om bepaalde acties in Sphere uit te voeren.",
  "Edit page": "Pagina wijzigen",
  "Print page": "Pagina uitprinten",
  "Page access": "Paginatoegang",
  "Who can view this page": "Wie kan deze pagina bekijken",
  "Page statistics": "Paginastatistieken",
  "Could not load the statistics": "Statistieken konden niet geladen worden",
  "In the last 90 days": "In de afgelopen 90 dagen",
  "Unique viewers": "Unieke bezoekers",
  "Total": "Totaal",
  "Page views": "Paginaweergaven",
  "Ekco users": "Ekco-gebruikers",
  "Customer users": "Klantgebruikers",
  "Public: visible to everyone": "Openbaar: zichtbaar voor iedereen",
  "Permissions (any of)": "Rechten (een van)",
  "None": "Geen",
  "Items per page": "Items per pagina",
  "Limit per page": "Limiet per pagina",
  "of": "van de",
  "---------- B2C ----------": "",
  "Owned Domains": "Jouw Domeinen",
  "Pending Verifications": "Lopende Verificaties",
  "Domain": "Domein",
  "Added": "Toegevoegd",
  "Requested": "Aangevraagd",
  "Time Remaining": "Resterende Tijd",
  "Sent to": "Gestuurd Naar",
  "Expired": "Verlopen",
  "Remove Domain Name": "Domeinnaam verwijderen",
  "If you later decide to add the domain name back, you'll have to go through the domain verification process again.": "Als je later beslist om de domeinnaam weer toe te voegen, dan moet je het verificatieproces opnieuw uitvoeren.",
  "Are you sure you want to unregister this domain?": "Weet je zeker dat je dit domein wilt uitschrijven?",
  "Since this is your last domain, removing it will disable the active login policy. Please acknowledge this before continuing.": "Omdat dit je laatste domein is, wordt het inlogbeleid uitgeschakeld als je deze verwijdert. Je moet dit erkennen voordat je verder kan gaan.",
  "I understand that by removing this domain I'm deactivating the login policy.": "Ik snap dat ik het inlogbeleid uitschakel door dit domein te verwijderen.",
  "Start Domain Verification": "Begin Domein Verificatie",
  "Enter a domain and an email address belonging to that domain. We'll send a code to this address to complete the domain verification process.": "Vul een domein en een emailadres dat bij dit domein hoort in. We sturen een code naar dit adres om het domein\u00adverificatie\u00adproces te voltooien.",
  "Verification Code Email": "Verificatiecode e-mail",
  "Start": "Beginnen",
  "Claim Domain Name": "Claim Domeinnaam",
  "Verification code": "Verificatiecode",
  "IP detection took too long.": "IP detectie duurde te lang.",
  "IP could not be found.": "IP kon niet gevonden worden.",
  "Add IPv4 Address": "IPv4 Adres Toevoegen",
  "Add IPv6 Address": "IPv6 Adres Toevoegen",
  "Add IPv6 Subnet /64": "IPv6 /64 Subnet Toevoegen",
  "Not loaded": "Niet ingeladen",
  "Based on": "Gebaseerd op",
  "Last Changed": "Laatst Gewijzigd",
  "View": "Bekijk",
  "Activate": "Activeren",
  "[singular]Activate": "Activeer",
  "Deactivate": "Deactiveren",
  "Active": "Actief",
  "Inactive": "Inactief",
  "Deactivated": "Gedeactiveerd",
  "Save": "Opslaan",
  "Edit": "Bewerken",
  "Edit as new version": "Bewerken als nieuwe versie",
  "Edit Login Policy": "Wijzig Inlogbeleid",
  "View Login Policy": "Bekijk Inlogbeleid",
  "Deactivate Login Policy": "Deactiveer Inlogbeleid",
  "Delete Login Policy": "Verwijder Inlogbeleid",
  "Version": "Versie",
  "Unverified domain": "Ongeverifieerd domein",
  "Some email domains have not been claimed by this customer. These users will not be checked by this customer's login policies.": "Sommige email domeinnamen zijn niet geclaimd door deze klant. Deze gebruikers worden niet gecontroleerd met inlogbeleid van deze klant.",
  "Login policies restrict how users with an email in the registered domains list can sign in to Sphere and our support portal.": "Een inlogbeleid beperkt hoe gebruikers met geregistreerde domeinen in hun email kunnen inloggen in Sphere en ons support portal.",
  "Login Policies": "Inlogbeleid",
  "Are you sure you want to create a new login policy?": "Weet je zeker dat je een nieuw inlogbeleid wilt maken?",
  "You already have an existing login policy. Instead of starting from scratch, you can create a new policy based on an existing one to copy over its settings and continue editing from there.": "Je hebt al een inlogbeleid. In plaat van opnieuw beginnen kan je ook een nieuwe versie maken gebaseerd op een bestaande inlogbeleid en deze daarna wijzigen.",
  "Create New Login Policy": "Nieuw inlogbeleid maken",
  "IP restrictions": "IP beperkingen",
  "Allowed IPs": "Toegestane IP's",
  "Warning, your IP is not on the allow list": "Waarschuwing, jouw IP staat niet op de toegestane lijst",
  "Are you sure you want to activate this login policy": "Weet je zeker dat je dit inlogbeleid wilt activeren?",
  "Are you sure you want to deactivate this login policy?": "Weet je zeker dat je dit inlogbeleid wilt deactiveren?",
  "Are you sure you want to delete this login policy?": "Weet je zeker dat je dit inlogbeleid wilt verwijderen?",
  "You have not yet verified a domain name, so you can't activate login policies.": "Je hebt nog geen domainnaam geverifieerd, dus je kan geen inlogbeleid activeren.",
  "Allowed sign-in methods": "Toegestane inlogmethodes",
  "Enable account Email OTP flag": "Zet account Email OTP aan",
  "Solely meant for initial onboarding of a customer's admin user that can only use Email OTP for login": "Alleen bedoeld for de onboarding van de eerste admin gebruikers van een klant die alleen Email OTP kan gebruiken voor inloggen",
  "---------- Router ----------": "",
  "Translation found": "Vertaling gevonden",
  "This page URL was found in Dutch. Would you like to show the translated page?": "Deze pagina-URL is in het Engels gevonden. Wil je de vertaalde pagina weergeven?",
  "Show": "Pagina weergeven",
  "Show translated page": "Vertaalde pagina weergeven",
  "--------- News ---------": "",
  "Created": "Aangemaakt",
  "Last updated": "Bijgewerkt",
  "--------- Sources ---------": "",
  "from mapping": "van mapping",
  "from mappings": "van mappings",
  "Delete Mapping?": "Verwijder Mapping?",
  "--------- Notifications ---------": "",
  "Notifications": "Notificaties",
  "Open notifications": "Open notificaties",
  "Mark all as read": "Markeer alles als gelezen",
  "Mark as read": "Markeer als gelezen",
  "Unread": "Ongelezen",
  "Refresh notifications": "Notificaties verversen",
  "--------- Feedback ---------": "",
  "star": "ster",
  "stars": "sterren",
  "Share your opinion!": "Geef je mening!",
  "We recently helped you with a question or resolved an issue. To keep improving our service, we would love to hear about your experience.": "Wij hebben je onlangs geholpen met het beantwoorden van een vraag of het wegnemen van een verstoring. Om onze dienstverlening te verbeteren horen wij graag hoe jouw ervaring is geweest.",
  "You would do us a great favour by leaving a rating.": "Je zou ons een groot plezier doen door een beoordeling te geven.",
  "One star means we have work to do, five stars means you found our service excellent.": "Bij één ster moeten we aan de slag om dit te verbeteren, bij vijf sterren vind je onze dienstverlening uitstekend.",
  "Would you like to add a comment?": "Wil je nog een toelichting geven?",
  "Thank you for your feedback!": "Bedankt voor je mening!",
  "We will use your feedback to improve our service!": "We gaan met je mening aan de slag!",
  "(You can safely close this screen now)": "(Je kunt dit scherm nu met een gerust hart sluiten)",
  "You have already submitted a rating for this request.": "Je hebt al een beoordeling gegeven voor dit verzoek.",
  "Too many attempts. Please try again tomorrow.": "Te veel pogingen. Probeer het morgen opnieuw.",
  "There was a problem with your submission.": "Er is een probleem met je invoer.",
  "Please check your input and try again.": "Controleer je invoer en probeer het opnieuw.",
  "Could not reach the server. Please check your connection and try again.": "Kan de server niet bereiken. Controleer je verbinding en probeer het opnieuw.",
  "Something went wrong on our end. Please try again later.": "Er is iets misgegaan aan onze kant. Probeer het later opnieuw.",
  "Would you like to send feedback or report a problem?": "Wil je feedback sturen of een probleem melden?",
  "Provide feedback": "Feedback geven",
  "Report a problem": "Probleem melden",
  "Enter a brief title": "Voer een korte titel in",
  "Describe the problem you are experiencing...": "Beschrijf het probleem dat je ervaart...",
  "Summary": "Samenvatting",
  "Products": "Producten",
  "Excluded products (customers without these products see this page)": "Uitgezonderde producten (enkel klanten zonder deze producten zien deze pagina)",
  "--------- dashboard ---------": "",
  "Edit Dashboard": "Dashboard bewerken",
  "Add Widgets": "Widgets toevoegen",
  "Done": "Klaar",
  "Permissions": "Rechten",
  "Your permissions": "Uw rechten",
  "Your assigned roles in Sphere": "Uw toegewezen rollen in Sphere",
  "Your assigned groups in Sphere": "Uw toegewezen groepen in Sphere",
  "Widget Library": "Widgets Overzicht",
  "No widgets": "Geen widgets beschikbaar",
  "Choose from a selection of available widgets and drag them to your dashboard": "Kies uit een selectie van beschikbare widgets en plaats ze op je dashboard.",
  "Profile": "Profiel",
  "Ekco Users": "Ekco Gebruikers",
  "Remove User?": "Gebruiker verwijderen?",
  "Are you sure you want to remove user": "Weet je zeker dat je deze gebruiker wilt verwijderen",
  "No roles assigned": "Geen rollen toegewezen",
  "No permissions": "Geen rechten",
  "No groups assigned": "Geen groepen toegewezen",
  "The user(s) will receive these permissions:": "De gebruiker(s) zullen deze rechten ontvangen:",
  "Guides": "Handleidingen",
  "Customer Success Manager": "Customer Success Manager",
  "Account Manager": "Account Manager",
  "No items": "Geen items",
  "Select problem type": "Selecteer probleem type",
  "Page URL": "Pagina URL",
  "Enter page URL": "Vul pagina URL in",
  "Thanks for your feedback! We will look into it and get in touch if we need anything more.": "Bedankt voor je feedback! We nemen het mee en nemen eventueel contact op als dat nodig is.",
  "Share your feedback with us...": "Deel je feedback met ons...",
  "A file with that name already exists.": "Er bestaat al een bestand met die naam.",
  "A folder with that name already exists.": "Er bestaat al een map met die naam.",
  "The name is the same as the current name.": "De naam is hetzelfde als de huidige naam.",
  "Filter by News Source": "Filteren op Nieuwsbron",
  "Clear filters": "Filters wissen",
  "Show all": "Alles tonen",
  "Apply": "Toepassen",
  "Success": "Succes",
  "---------- Service Desk ----------": "",
  "Service Tickets": "Servicetickets",
  "Back to Service Desk": "Terug naar Service Desk",
  "View all tickets": "Alle tickets weergeven",
  "Open Tickets": "Openstaande Tickets",
  "Open Requests": "Openstaande Verzoeken",
  "View Closed Tickets": "Bekijk Gesloten Tickets",
  "View Open Tickets": "Bekijk Openstaande Tickets",
  "Waiting for You": "Wachten op Jou",
  "How can we help you?": "Hoe kunnen we je helpen?",
  "Tell us about the issue to get solutions and support. Don't include personal or confidential information like passwords.": "Vertel ons over het probleem om oplossingen en ondersteuning te krijgen. Voeg geen persoonlijke of vertrouwelijke informatie toe zoals wachtwoorden.",
  "I know exactly what support I need, get me there": "Ik weet precies welke ondersteuning ik nodig heb, breng me daar",
  "Please provide more details about your request": "Geef alstublieft meer details over uw verzoek",
  "Clear": "Wissen",
  "Submit Request": "Verzoek indienen",
  "Dismiss message": "Bericht sluiten",
  "Items That Need Your Attention": "Items die uw aandacht nodig hebben",
  "No items need your attention": "Geen items hebben uw aandacht nodig",
  "View all items needing attention": "Alle items weergeven die aandacht nodig hebben",
  "No open tickets": "Geen openstaande tickets",
  "View all open tickets": "Alle openstaande tickets weergeven",
  "Quick Actions": "Snelle acties",
  "No quick actions available": "Geen snelle acties beschikbaar",
  "Last Used Service Requests": "Meest gebruikte serviceverzoeken",
  "No recent service requests": "Geen recente serviceverzoeken",
  "Assigned to": "Toegewezen aan",
  "Unknown": "Onbekend",
  "most recent": "meest recent",
  "min": "min",
  "mins": "minuten",
  "hour": "uur",
  "hours": "uren",
  "day": "dag",
  "days": "dagen",
  "ago": "geleden",
  "Claim": "Claimen",
  "New Ticket": "Nieuw Ticket",
  "Ticket Opened": "Ticket Geopend",
  "Info": "Info",
  "Error": "Fout",
  "Notice": "Melding",
  "Resolved": "Opgelost",
  "Warning": "Waarschuwing",

  "You will be redirected to create a ticket in a new window.": "Je wordt doorgestuurd om een ticket aan te maken in een nieuw venster.",
  "You will be redirected to the selected ticket in a new window.": "Je wordt doorgestuurd naar het geselecteerde ticket in een nieuw venster.",
  "Closing this popup will synchronize your changes with Sphere right away.": "Het sluiten van deze popup zal je wijzigingen meteen synchroniseren met Sphere.",
  "Sync": "Synchroniseren",
  "No roles available to assign.": "Geen rollen beschikbaar om toe te wijzen.",
  "Direct": "Direct",
  "Indirect": "Direct",
  "Add to dashboard to view": "Toevoegen aan dashboard om te bekijken",
  "This widget has no URL": "Deze widget heeft geen URL",
  "Cannot deactivate the active demo customer": "Kan niet de actieve demo-klant deactiveren",
  "Continue to Sphere": "Ga door naar Sphere",
  "Rating": "Beoordeling",
  "On this page": "Op deze pagina",
  "Pending": "In afwachting",
  "Ekco users already exist and can be granted extra roles after they log in.": "Ekco users bestaan al en kunnen extra rollen krijgen nadat ze zijn ingelogd",
  "Contact": "Contact",
  "Activity": "Activiteit",
  "Demo": "Demo",
  "Live": "Live",
  "No": "Nee",
  "Any": "Alle",
  "Include": "Opnemen",
  "Exclude": "Uitsluiten",
  "Included": "Opgenomen",
  "Excluded": "Uitgesloten",
  "Other filters": "Overige filters",
  "No results": "Geen resultaten",
  "Filters": "Filters",
  "Filter": "Filter",
  "Reset Filter": "Filter wissen",
  "Export": "Exporteren",
  "Export the users matching the filters to Excel": "Exporteer de gebruikers die aan de filters voldoen naar Excel",
  "Customer Has Products": "Klant heeft producten",
  "Customer Product Count": "Aantal producten van klant",
  "Exact": "Exact",
  "More than": "Meer dan",
  "Fewer than": "Minder dan",
  "Has Products": "Heeft producten",
  "Product Count": "Aantal producten",
  "Has Users": "Heeft gebruikers",
  "Has Activity": "Heeft activiteit",
  "User Count": "Aantal gebruikers",
  "Active User Days (last 90 days)": "Actieve gebruikersdagen (laatste 90 dagen)",
  "Active Days (last 90 days)": "Actieve dagen (laatste 90 dagen)",
  "Last Activity": "Laatste activiteit",
  "Last activity after": "Laatste activiteit na",
  "Last activity before": "Laatste activiteit voor",
  "Has Roles": "Heeft rollen",
  "Customer Missing Contract Documents": "Klant mist contractdocumenten",
  "Missing Contract Documents": "Contractdocumenten ontbreken",
  "Multiple Customers": "Meerdere klanten",
  "Based on a scan that only runs hourly.": "Gebaseerd op een scan die slechts elk uur draait.",
  "Active Days": "Actieve dagen",
  "Sum of the daily number of active customer users over the last 90 days.": "Som van het dagelijkse aantal actieve klantgebruikers over de afgelopen 90 dagen.",
  "Number of days the user was active in the last 90 days.": "Aantal dagen dat de gebruiker actief was in de afgelopen 90 dagen.",
  "Has Active Invitations": "Heeft actieve uitnodigingen",
  "Has Expired Invitations": "Heeft verlopen uitnodigingen",
  "Please choose a user and a title": "Kies een gebruiker en een functie",
  "Please choose an option": "Kies een optie",
  "Contract not uploaded": "Contract niet geüpload",
  "Contract uploaded": "Contract geüpload"
}
